msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fr\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-27 06:16\n"
"Last-Translator: \n"
"Language-Team: French\n"
"Plural-Forms: nplurals=2; plural=(n > 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: fr\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Verrouillé"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Messages : {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Dernier message : {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatisé"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "Groupe"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Suivi mutuel"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Demandé"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Abonnements"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Vous suit"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# abonné⋅e} other {# abonné⋅es}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Vérifié"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "Inscrit·e depuis le <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Pour toujours"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Le compte n’a pas pu être chargé."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Aller à la page du compte"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Abonné⋅e·s"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Messages"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Plus"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> a désormais le nouveau compte suivant :"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Identifiant copié"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "L’identifiant n’a pas pu être copié."

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Copier l’identifiant"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Visiter la page de profil originale"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Afficher l’image de profil"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Afficher la bannière de profil"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Cette personne ne souhaite pas partager cette information."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} messages, {1} réponses, {2} partages"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Dernier message aujourd’hui} other {Dernier message ces {2} derniers jours}}} other {{3, plural, one {{4} messages les plus récents aujourd’hui} other {{5} messages les plus récents ces {6} derniers jours}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Dernier 1 message dans les dernières années} other {Derniers {1} messages dans les dernières années}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Messages"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Réponses"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Partages"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Les statistiques de ce message ne sont pas disponibles."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Voir les statistiques de publication"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Dernier message : <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Masqué⋅e"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Bloqué⋅e"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Note personnelle"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Mentionner <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Traduire la bio"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Modifier les notes personnelles"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Ajouter une note personnelle"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notifications activées pour les messages de @{username}."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Notifications désactivées pour les messages de @{username}."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Désactiver les notifications"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Activer les notifications"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Partages affichés pour @{username}."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Partages masqués pour @{username}."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Masquer les partages"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Afficher les partages"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Ajouter ou retirer des listes"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Lien copié"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "Le lien n’a pas pu être copié."

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Copier"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Le partage ne paraît pas possible."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Partager…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "@{username} n’est plus masqué⋅e"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Ne plus masquer <0>@{username}></0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Masquer <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "@{username} masqué⋅e pendant {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "Impossible de masquer @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Retirer <0>@{username}</0> de vos abonné⋅e·s ?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} retiré⋅e de vos abonné⋅es"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Retirer de vos abonné⋅es…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "Bloquer <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "@{username} débloqué⋅e"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "@{username} bloqué⋅e"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "Impossible de débloquer @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "Impossible de bloquer @{username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Débloquer <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Bloquer <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Signaler <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Modifier votre profil"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Annuler la demande de suivi ?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "Ne plus suivre @{0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Ne plus suivre…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Annuler…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Suivre"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Fermer"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Bio traduite"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "Impossible de retirer de la liste."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "Impossible d’ajouter à la liste."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Les listes n’ont pas pu être chargées."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "Aucune liste."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nouvelle liste"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Note personnelle à propos de <0>@{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "Les notes personnelles n’ont pas pu être enregistrées."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Annuler"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Enregistrer et quitter"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "Le profil n’a pas pu être enregistré."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Bio"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Champs personnalisés"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Titre"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Contenu"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Enregistrer"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "identifiant"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "nom de domaine"

#: src/components/background-service.jsx:138
msgid "Cloak mode disabled"
msgstr "Mode camouflage désactivé"

#: src/components/background-service.jsx:138
msgid "Cloak mode enabled"
msgstr "Mode camouflage activé"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Accueil"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Rédiger"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Le message n’est pas sauvegardé. Annuler sa rédaction ?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Vous ne pouvez joindre qu’un seul fichier.} other {Vous pouvez joindre jusqu’à # fichiers.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Ouvrir dans une nouvelle fenêtre"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Minimiser"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Il semblerait que vous ayez fermé la fenêtre d’origine."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Il semblerait que vous ayez déjà un message en cours de publication ouvert dans la fenêtre d’origine. Merci de réessayer une fois ce message publié."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Il semblerait que vous ayez déjà un message en cours de rédaction dans la fenêtre d’origine. Restaurer cette fenêtre annulera la rédaction du message de la fenêtre d’origine sans sauvegarder. Continuer ?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Restaurer dans la fenêtre d’origine"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "En réponse au message de @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "En réponse au message de @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Modification du message d’origine"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "Au moins deux choix sont nécessaires pour un sondage"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Tous les choix du sondage ne sont pas renseignés"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Les médias n’ont pas tous de descriptions renseignées. Continuer ?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "#{i} n’a pas pu être joint au message"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "Avertissement de contenu"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Avertissement de contenu ou média délicat"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Public"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Non-listé"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Abonné⋅es seulement"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Mention privée"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Publier votre réponse"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Modifier votre message"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "Quoi de neuf ?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Marquer le média comme délicat"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Insérer un sondage"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Insérer un émoji personnalisé"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Répondre"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Mettre à jour"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publier"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "Téléchargement du GIF…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Le GIF n’a pas pu être téléchargé."

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Plus…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Chargé"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Description de l’image"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Description de la vidéo"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Description de l’audio"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Ce fichier est trop lourd. Son chargement pourrait échouer. Essayez de réduire son poids de {0} à {1} ou moins."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Ce média est trop grand. Son chargement pourrait échouer. Essayez de réduire sa taille de {0}×{1} px à {2}×{3} px."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Ce média a une fréquence trop élevée. Son chargement pourrait échouer."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Supprimer"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Erreur"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Modifier la description de l’image"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Modifier la description de la vidéo"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Modifier la description de l’audio"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Description en cours de génération. Merci de patienter…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Échec lors de la génération d’une description : {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Échec lors de la génération d’une description"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Générer une description…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Échec lors de la génération d’une description{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— expérimental</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Enregistrer"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "Choix {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Choix multiples"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Durée"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Supprimer le sondage"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Chercher des comptes"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Insérer"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Les comptes n’ont pas pu être chargés"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Émojis personnalisés"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Chercher un émoji"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Les émojis personnalisés n’ont pas pu être chargés"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Récemment insérés"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Autres"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} de plus…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Chercher des GIFs"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Propulsé par GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Entrez votre recherche pour trouver des GIFs"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "Précédent"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "Suivant"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Erreur lors du chargement des GIFs"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Brouillons non envoyés"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "On dirait que vous avez des brouillons non envoyés. Continuons là où vous l'avez laissé."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Supprimer ce brouillon ?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Erreur lors de la suppression du brouillon. Veuillez réessayer."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Supprimer…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Erreur lors de la récupération du statut de la réponse !"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Supprimer tous les brouillons ?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Erreur lors de la suppression des brouillons ! Veuillez réessayer."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Tout supprimer…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Pas de brouillon trouvé."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "Sondage"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Média"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Ouvrir dans une nouvelle fenêtre"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Accepter"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Rejeter"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Acceptée"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Rejetée"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Rien à afficher"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Comptes"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Voir plus…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "C'est fini."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "Raccourcis clavier"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Aide pour les raccourcis clavier"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "Message suivant"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "Message précédent"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Passer le carrousel au message suivant"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Maj</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Passer le carrousel au message précédent"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Maj</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Charger de nouveaux messages"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "Ouvrir les détails du message"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Entrée</0> ou <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Développer l'avertissement de contenu ou<0/>activer/désactiver le fil étendu/réduit"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Fermer la publication ou les boîtes de dialogue"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Échap</0> ou <1>Retour arrière</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Focus colonne en mode multi-colonnes"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> à <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Rédiger un nouveau message"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Rédiger un nouveau message (nouvelle fenêtre)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Maj</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Publier message"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Entrée</1> ou <2>⌘</2> + <3>Entrée</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Recherche"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Répondre (nouvelle fenêtre)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Maj</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Ajouter en favori"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> ou <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Partager"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Maj</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Ajouter aux signets"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Activer/Désactiver le mode camouflage"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Maj</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Modifier la liste"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "La liste n’a pas pu être modifiée."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "La liste n’a pas pu être créée."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nom"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Afficher les réponses aux membres de la liste"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Afficher les réponses aux personnes que je suis"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Ne pas afficher les réponses"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Masquer les messages de cette liste sur l'Accueil/Abonnements"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Créer"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Supprimer cette liste ?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "La liste n’a pas pu être supprimée."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Description du média"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Traduire"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Prononcer"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Ouvrir le média d'origine dans une nouvelle fenêtre"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Ouvrir le média d'origine"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Tentative de description de l'image. Veuillez patienter…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "La description de l'image a échoué"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Décrivez l'image…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Voir la publication"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Média délicat"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtré : {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "Filtré"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Message publié. Voir le message."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Réponse publiée. Consultez-la."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Message mis à jour. Voir le message."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Recharger la page maintenant pour la mettre à jour ?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nouvelle mise à jour disponible…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr "Rattrapage"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Mentions"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Notifications"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nouveau"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Listes"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Toutes les listes"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Signets"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Favoris"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Hashtags suivis"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtres"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Comptes masqués"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Comptes masqués…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Compte bloqués"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Comptes bloqués…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Comptes…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Connexion"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Tendances"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Local"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Fédéré"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Raccourcis / Colonnes…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Préférences…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Notification"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Cette notification provient de votre autre compte."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Voir toutes les notifications"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} a réagi à votre publication avec {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} a publié un message."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} a partagé votre réponse.} other {{account} a partagé votre message.}}} other {{account} a partagé {postsCount} de vos messages.}}} other {{postType, select, reply {<0><1>{0}</1> personnes </0> ont partagé votre réponse.} other {<2><3>{1}</3> personnes</2> ont partagé votre message.}}}}"

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account} vous a suivi.} other {<0><1>{0}</1> personnes</0> vous ont suivi.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} a demandé à vous suivre."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} a aimé votre réponse.} other {{account} a aimé votre message.}}} other {{account} a aimé {postsCount} de vos messages.}}} other {{postType, select, reply {<0><1>{0}</1> personnes </0> ont aimé votre réponse.} other {<2><3>{1}</3> personnes</2> ont aimé votre message.}}}}"

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Un sondage que vous avez créé ou auquel vous avez répondu est terminé."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "Un sondage que vous avez créé est terminé."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "Un sondage auquel vous avez répondu est maintenant terminé."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Un message auquel vous avez réagi a été modifié."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} a boosté et aimé votre réponse.} other {{account} a boosté et aimé votre message.}}} other {{account} a boosté et aimé {postsCount} de vos messages.}}} other {{postType, select, reply {<0><1>{0}</1> personnes </0> ont boosté et aimé votre réponse.} other {<2><3>{1}</3> personnes</2> ont boosté et aimé votre message.}}}}"

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} s'est inscrit·e."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} a signalé {targetAccount}"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "Connexions perdues avec <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Avertissement de modération"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Un·e administrateur·rice de <0>{from}</0> a suspendu <1>{targetName}</1>, ce qui signifie que vous ne pourrez plus recevoir ses mises à jour ou interagir avec lui."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "L’administration de <0>{from}</0> a bloqué <1>{targetName}</1>. Le blocage concerne {followersCount} de vos abonné⋅es et {followingCount} de vos abonnements."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Vous avez bloqué <0>{targetName}</0>. Le blocage concerne {followersCount} de vos abonné⋅es et {followingCount} de vos abonnements."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Votre compte a reçu un avertissement de modération."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Votre compte a été désactivé."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Certains de vos messages ont été marqués comme délicats."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Certaines de vos publications ont été supprimées."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "Vos messages seront dorénavant marqués comme délicats."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Votre compte est restreint."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Votre compte a été suspendu."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Notification de type inconnu : {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Partagée par / Aimée par …"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Aimée par…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Partagé par…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Suivi par…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "En savoir plus <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Lire la suite →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "A voté"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Masquer les résultats"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Voter"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Actualiser"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Montrer les résultats"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votant} other {<1>{1}</1> votants}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "Est clôturé <0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Est clos"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "Se termine <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Sera clos"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Liens malveillants, faux engagement ou réponses répétitives"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Illégal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viole la loi de votre pays ou celui du serveur"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Violation de règle du serveur"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Viole des règles spécifiques du serveur"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Infraction"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Autre"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Le problème ne correspond pas aux autres catégories"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Signaler le message"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Signaler @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "En attente de révision"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Message signalé"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profil signalé"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Le message n’a pas pu être signalé"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Le profil n’a pas pu être signalé."

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Quel est le problème avec cette publication ?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Quel est le problème avec ce profil ?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informations complémentaires"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Transférer vers <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Envoyer le rapport"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Compte {username} masqué"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "{username} n’a pas pu être masqué."

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Signaler <0>+ Masquer le profil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Compte {username} bloqué"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "{username} n’a pas pu être bloqué."

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Signaler <0>+ Bloquer le profil</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ comptes, hashtags et publications</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Messages avec <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Messages avec le mot-clé <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Rechercher <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Comptes avec <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Accueil / Abonnements"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Public (local / fédéré)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Compte"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID de la liste"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Local uniquement"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instance"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Facultatif, par exemple “mastodon.social”"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Terme de recherche"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Facultatif, sauf pour le mode multicolonnes"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "ex : PixelArt (max 5, séparés par des espaces)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Média uniquement"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Raccourcis"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "bêta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Spécifiez une liste de raccourcis qui apparaîtront comme :"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Bouton flottant"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Onglet/Barre de menu"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Multi-colonnes"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "Non disponible dans le mode d'affichage actuel"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Déplacer vers le haut"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Déplacer vers le bas"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Modifier"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Ajouter plus d'un raccourci/colonne pour que ceci puisse fonctionner."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "Aucune colonne pour l'instant. Appuyez sur le bouton Ajouter."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Aucun raccourci pour le moment. Appuyez sur le bouton Ajouter un raccourci."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Vous ne savez pas quoi ajouter ?<0/>Essayez d'abord d'ajouter <1>Accueil / Abonnements et Notifications</1> ."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Maximum de colonnes {SHORTCUTS_LIMIT}"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Maximum de raccourcis {SHORTCUTS_LIMIT}"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Importer/Exporter"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Ajouter une colonne…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Ajouter un raccourci…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "La liste spécifique est facultative. La liste est obligatoire pour le mode multi-colonnes, sinon la colonne ne sera pas affichée."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Pour le mode multi-colonnes, le terme de recherche est obligatoire, sinon la colonne ne sera pas affichée."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Plusieurs hashtags sont pris en charge. Séparés par des espaces."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Modifier le raccourci"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Ajouter un raccourci"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Fil d’actualité"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Liste"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importer/Exporter des <0>raccourcis</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Importer"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Coller les raccourcis ici"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "Chargement des raccourcis depuis votre instance…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "Les raccourcis n’ont pas pu être chargés."

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Charger les raccourcis depuis votre instance"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* Existe dans les raccourcis actuels"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "La liste pourrait ne pas fonctionner si elle provient d'un autre compte."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Format de paramètres non valide"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "Remplacer les raccourcis actuels ?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "Aucun nouveau raccourci à importer"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Raccourcis importés. Dépassement du maximum {SHORTCUTS_LIMIT}, donc les autres ne sont pas importés."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Raccourcis importés"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Importer et ajouter…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "Remplacer les raccourcis actuels ?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "Importer les raccourcis ?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "ou remplacer…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Importer…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Exporter"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "Raccourcis copiés"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "Les raccourcis n’ont pas pu être copiés."

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "Les paramètres des raccourcis ont été copiés"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "Les paramètres de raccourcis n’ont pas pu être copiés."

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Partager"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "Enregistrement des raccourcis sur votre instance…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "Raccourcis enregistrés"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "Les raccourcis n’ont pas pu être sauvegardés."

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Synchroniser avec votre instance"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0,plural, one{# caractère} other{# caractères}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "Raccourcis JSON bruts"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importer/exporter les paramètres de/vers l'instance du serveur (très expérimental)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>a partagé</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr ""

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "Message de @{0} retiré des favoris"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "Message de @{0} ajouté en favori"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "Message de @{0} retiré des signets"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "Message de @{0} ajouté aux signets"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Annuler le partage"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Citer"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "Certains médias n'ont pas de descriptions."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Ancien message (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "Partage du message de @{0} annulé"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "Message de @{0} partagé"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Partager…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "Retirer des favoris"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "Ajouter en favori"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Retirer des signets"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Voir la publication de <0>@{0}</0>"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Afficher l’historique des modifications"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Modifié : {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Intégrer la publication"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "La discussion n'est plus masquée"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Conversation mise en silence"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "La conversation n’a pas pu être rétablie."

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "La conversation n’a pas pu être mise en sourdine."

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Ne plus masquer la discussion"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Mettre la conversation en sourdine"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "Message détaché du profil"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "Message épinglé au profil"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "Le message n’a pas pu être détaché."

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "Le message n’a pas pu être épinglé."

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Détacher de votre profil"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Épingler à votre profil"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "Supprimer cette publication ?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Message supprimé"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "Le message n’a pas pu être supprimé."

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Signaler la publication…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "Favori"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Partagé"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Signet"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Épinglé"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Supprimée"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# réponse} other {# réponses}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Fil{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Replier"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Afficher le contenu"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Afficher le média"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Modifié"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Commentaires"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Historique des modifications"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "Échec du chargement de l'historique"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Chargement en cours…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "Code HTML"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "Code HTML copié"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "Le code HTML n’a pas pu être copié."

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Médias attachés :"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Émojis du compte :"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "URL statique"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Émojis :"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Remarques :"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Ceci est statique, non stylisé et sans script. Vous devrez peut-être appliquer vos propres styles et les modifier au besoin."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "Le message pourrait être modifié ou supprimé plus tard."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Aperçu"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Remarque : Cet aperçu est légèrement stylisé."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> a partagé"

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Nouveaux messages"

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Essayez à nouveau"

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "Fils"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtré</0> : <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Traduit automatiquement depuis {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Traduction en cours…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traduire à partir de {sourceLangText} (auto-détect)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Traduction depuis {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "La traduction a échoué"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr ""

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "En réponse à @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Cette page peut être fermée."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Fermer la fenêtre"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Connexion requise."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Retour à l’accueil"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Publications du compte"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Réponses)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (− Partages)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Média)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Effacer les filtres"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Effacer"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Voir la publication avec ses réponses"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Réponses"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Affichage des messages sans les partages"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "− Partages"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Afficher les publications avec médias"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Affichage des messages marqués avec #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Affichage des messages dans {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Rien à voir ici pour le moment."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "Les messages n’ont pas pu être chargés."

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Les informations sur le compte n’ont pas pu être chargés."

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Basculer vers l'instance du compte {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Passer à mon instance (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mois"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Actuel"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Par défaut"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Basculer vers ce compte"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Voir le profil…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Définir par défaut"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Se déconnecter de <0>@{0}</0> ?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Se déconnecter…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Ajouter un compte existant"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Les signets n’ont pas pu être chargés."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "dernière heure"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "les 2 dernières heures"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "3 dernières heures"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "4 dernières heures"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "5 dernières heures"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "6 dernières heures"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "7 dernières heures"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "8 dernières heures"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "9 dernières heures"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "10 dernières heures"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "11 dernières heures"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "12 dernières heures"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "12 dernières heures et plus"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Mots-clés suivis"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Groupes"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "{selectedFilterCategory, select, all {Tous types de messages} original {Messages originaux} replies {Messages de réponse} boosts {Partages} followedTags {Mots-clés suivis} groups {Groupes} filtered {Messages filtrés}}, {sortBy, select, createdAt {{sortOrder, select, asc {les plus vieux} desc {les plus récents}}} reblogsCount {{sortOrder, select, asc {les moins partagés} desc {les plus partagés}}} favouritesCount {{sortOrder, select, asc {les moins favoris} desc {les plus favoris}}} repliesCount {{sortOrder, select, asc {le moins de réponses} desc {le plus de réponses}}} density {{sortOrder, select, asc {les moins denses} desc {les plus denses}}}} en premier{groupBy, select, account {, groupé par personne} other {}}"

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr "Rattrapage <0>bêta</0>"

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr "Aide"

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "En savoir plus"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Le rattrapage est un fil d’actualité supplémentaire qui propose une vue d’ensemble pour rester à la page avec vos abonnements. Son interface est inspirée par les e-mails et vous permet de filtrer et trier les messages facilement."

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr "Aperçu de l’interface de rattrapage"

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr "C’est parti"

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr "Restez à la page avec vos abonnements."

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "Afficher tous les messages qui datent de…"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr "autant que possible"

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr "Rattrapage"

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr "En commun avec votre rattrapage précédent"

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr "Depuis le dernier rattrapage ({0})"

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "À noter : il se peut que votre instance ne montre que 800 messages dans le fil d’actualité, plus ou moins, quelle que soit la tranche horaire choisie."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "Précédemment…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# message} other {# messages}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr "Enlever ce rattrapage ?"

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Seulement trois rattrapages sont sauvegardés. Les autres seront automatiquement supprimés."

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr "Chargement des messages…"

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr "Merci de patienter."

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr "Réinitialiser les filtres"

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr "Liens populaires"

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr "Partagé par {0}"

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Tous"

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# personne} other {# personnes}}"

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr "Classer"

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr "Date"

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr "Densité"

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr "Par personne"

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr "Aucun"

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr "Afficher tout le monde"

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr "Pas la peine de tout lire."

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr "C’est tout !"

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr "Remonter"

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Ce sont les liens partagés par les personnes que vous suivez, classés selon leur nombre d’apparences, de partages et de favoris."

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr "Classer par densité"

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Classe les messages selon leur densité d’information. Les messages plus courts ou sans images sont plus “légers”, les messages plus longs ou avec des images sont plus “lourds”."

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr "Groupé par personne"

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Les publications sont regroupées par auteur·ice·s, triées par nombre de messages par auteur·ice."

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr "Personne suivante"

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr "Personne précédente"

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr "Remonter"

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr "Filtré : {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Les favoris n’ont pas pu être chargés."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Principal et listes"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Fils publics"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Discussions"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profils"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Jamais"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nouveau Filtre"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtre} other {# filtres}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Les filtres n’ont pas pu être chargés."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Aucun filtre pour l'instant."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Ajouter un filtre"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Modifier le filtre"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Le filtre n’a pas pu être modifié."

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Le filtre n’a pas pu être créé"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Titre"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Mot entier"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Aucun mot clé. Ajoutez-en un."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Ajouter un mot clé"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# mot-clé} other {# mots-clés}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtrer depuis…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Pas encore implémentée"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Statut : <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Modifier l'expiration"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Expiration"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Les messages filtrés seront …"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimisé"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "masqué"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Supprimer ce filtre ?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Le filtre n’a pas pu être supprimé."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Expiré"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Expire <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "N’expire jamais"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtags}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Les mot-clés suivis n’ont pas pu être chargés."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Aucun hashtag n'a encore été suivi."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "Rien à voir ici."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Les messages n’ont pas pu être chargés."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Média uniquement) sur {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} sur {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Média uniquement)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Personne n'a encore publié de message avec ce mot croisillon."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Les messages avec ce mot-clé n’ont pas pu être chargés."

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Arrêt du suivi de #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Abonné·e à #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Suivre…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Retiré du profil"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Le mot-clé n’a pas pu être retiré du profil."

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Mis en avant sur votre profil"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Mettre en avant sur votre profil"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {Max # hashtags}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Ajoute un hashtag"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Retirer le hashtag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {La limite de # raccourci a été atteinte. Le raccourci n’a pas pu être ajouté.} other {La limite de # raccourcis a été atteinte. Le raccourci n’a pas pu être ajouté.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Ce raccourci existe déjà"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Raccourci du hashtag ajouté"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Ajouter aux raccourcis"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Indiquer une nouvelle instance, par exemple “mastodon.social”"

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "Instance incorrecte"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Afficher une autre instance…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Afficher mon instance (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "Les notification n’ont pas pu être chargées."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nouvelle</0> <1>demande d'abonnement</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "Tout voir"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Résolution en cours …"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "L’URL n’a pas été trouvée."

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Rien pour l’instant."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Gestion des membres"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Retirer <0>@{0}</0> de la liste ?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Retirer…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# liste} other {# listes}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Aucune liste pour le moment."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "Par exemple “mastodon.social”"

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr "Connexion échouée. Essayez à nouveau, ou avec une autre instance."

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "Continuer sur {selectedInstanceText}"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "Continuer"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "Pas de compte ? Créez-en un !"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Mentions privées"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privées"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Personne ne vous a mentionné :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Les mentions n’ont pas pu être chargées."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "Que vous ne suivez pas"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Qui ne sont pas abonné·e·s à vous"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "Ayant un nouveau compte"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr "Qui vous mentionnent en privé de façon inattendue"

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr "Qui sont limité·e·s par les modérateur·rice·s du serveur"

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Préférences des notifications"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Nouvelles notifications"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Annonce} other {Annonces}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "Demandes d’abonnement"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# demande d'abonnement} other {# demandes d'abonnement}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Mentions seulement"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Aujourd’hui"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "Vous avez tout rattrapé."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Hier"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "Les notifications n’ont pas pu être chargées."

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "Préférences de notification mises à jour"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Masquer les notifications provenant de gens :"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Filtrer"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ignorer"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "Mis à jour <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "Voir les notifications de <0>@{0}</0>"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "Notifications de <0>@{0}</0>"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Les notifications provenant de @{0} seront dorénavant masquées."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "La demande de notification n’a pas pu être acceptée"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Autoriser"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "La demande de notification n’a pas pu être annulée."

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Ignorer"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Fil local ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Fil fédéré ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Fil local"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Fil fédéré"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Personne n’a encore rien publié."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Basculer vers le fil fédéré"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Passer au fil local"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Recherche : {q} (Messages)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Recherche : {q} (Comptes)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Recherche : {q} (Hashtags)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Rechercher : {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Voir plus"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Afficher plus de comptes"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Aucun compte trouvé."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Voir plus de hashtags"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Aucun hashtag trouvé."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Voir plus de publications"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Aucune publication trouvée."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Entrez le terme recherché ou collez une URL ci-dessus pour commencer."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Paramètres"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Affichage"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Clair"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Sombre"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Auto"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Taille du texte"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "Langue d'affichage"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr ""

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "Publication"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "Visibilité par défaut"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "Synchronisé"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "Échec de la mise à jour de la confidentialité du mode de publication"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Synchronisé avec les paramètres de votre serveur d'instance. <0>Allez à votre instance ({instance}) pour plus de paramètres.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "Expérimentations"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "Charger automatiquement les messages du fil d’actualité"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "Carrousel des partages"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "Traduction des messages"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Traduire vers"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "Langue système ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Masquer le bouton \"Traduire\" pour:} other {Masquer le bouton \"Traduire\" pour (#):}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Remarque : Cette fonctionnalité utilise des services de traduction externes, propulsés par <0>Lingva API</0> & <1>Lingva Translate</1>."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Affiche automatiquement la traduction des messages sur le fil d’actualité. Ne fonctionne qu’avec les messages <0>courts</0> sans médias, ni sondages, ni avertissement de contenu."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "Sélecteur de GIFs lors de la rédaction"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Générateur de description d'images"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "Uniquement pour les nouvelles images lors de la rédaction de nouvelles publications."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Remarque : Cette fonction utilise un service IA externe, propulsé par <0>img-alt-api</0>. Peut ne pas fonctionner correctement. Seulement pour les images et en anglais."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "Notifications groupées côté serveur"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Import/export \"Cloud\" pour les paramètres des raccourcis"

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Très expérimental.<0/>Enregistré dans les notes personnelles de votre propre profil. Ces notes, privées, sont généralement utilisées sur les profils des autres, et masquées sur le votre."

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Note : Cette fonction utilise l'API du serveur d'instance auquel vous êtes actuellement connecté."

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Mode camouflage <0>(<1>Texte</1> → <2>█████</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Masque le texte avec des rectangles, pratique pour prendre des captures d’écran de manière respectueuse de la vie privée."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "À propos"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Fait</0> par <1>@cheeaun</1>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "Parrain"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Faire un don"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Politique de confidentialité"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>Site:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Version:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "Texte de version copié"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "Le numéro de version n’a pas pu être copié."

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "La mise à jour de l'abonnement a échoué. Veuillez réessayer."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr "La suppression de l'abonnement a échoué. Veuillez réessayer."

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Notifications Push (bêta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Les notifications push sont bloquées. Veuillez les activer dans les paramètres de votre navigateur."

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "Permettre depuis <0>{0}</0>"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "tout le monde"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "personnes à lesquelles je suis abonné·e"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "abonné⋅es"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "Abonnements"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Sondages"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "Modifications du message"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "L'autorisation des notifications Push n'a pas été accordée depuis votre dernière connexion. Vous devrez <0><1>vous connecter</1> à nouveau pour accorder l'autorisation Push</0>."

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTE : Les notifications Push ne fonctionnent que pour <0>un compte</0>."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Publication"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Vous n’êtes pas connecté⋅e. Les interactions telles que les réponses et les partages ne sont pas possibles."

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Ce message provient d’une autre instance (<0>{instance}</0>). Les interactions telles que les réponses et les partages ne sont pas possibles."

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Erreur : {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr "Basculer vers mon instance pour activer les interactions"

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "Les réponses n’ont pas pu être chargées."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Retour"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "Aller au message principal"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr "{0} messages plus haut ‒ Remonter"

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr "Passer en vue latérale"

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr "Passer en vue pleine page"

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr "Afficher tous les contenus sensibles"

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Expérimental"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "Impossible de basculer"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "Basculer vers l'instance de la publication ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "Basculer vers l'instance de la publication"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "Le message n’a pas pu être chargé."

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# réponse} other {<0>{1}</0> réponses}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# commentaire} other {<0>{0}</0> commentaires}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "Voir la publication avec ses réponses"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "Tendances ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Actualités en tendance"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "Retour à l'affichage des publications en tendance"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Affichage des messages mentionnant <0>{0}</0>"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "Publications en tendance"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "Pas de publications en tendance."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Un client Mastodon minimaliste et original."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Se connecter avec Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "S’inscrire"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Connectez votre compte Mastodon/Fédivers existant.<0/>Votre mot de passe ne sera pas enregistré sur ce serveur."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Fabriqué</0> par <1>@cheeaun</1>. <2>Politique de confidentialité</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Capture d’écran du carrousel des partages"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Carrousel des partages"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Distingue visuellement les messages de vos abonnements et les messages partagés."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Capture d’écran de commentaires imbriqués"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Commentaires imbriqués"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Facile de suivre les conversations. Commentaires semi-repliables."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Capture d’écran de notifications groupées"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Notifications groupées"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Les notifications similaires sont groupées et réduites pour éviter le désordre."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Capture d’écran de l’interface à plusieurs colonnes"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Une ou plusieurs colonnes"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Une seule colonne par défaut pour une ambiance zen. Plusieurs colonnes configurables pour les plus braves."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Capture d’écran du fil d’actualité à multiples mots-clés, avec un champs pour ajouter des mots-clés"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Fil d’actualité à mots-clés multiples"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Jusqu’à 5 mots-clés combinés dans un seul fil."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Il semblerait que votre navigateur bloque les fenêtres pop-up."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Un message en cours de rédaction est actuellement minimisé. Publiez ou annulez-le avant d’en rédiger un nouveau."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Un message est actuellement en cours de rédaction. Publiez ou annulez-le avant d’en rédiger un nouveau."

